import FundLogDBService from "../../db-services/fundLogDBService";
import { ILogResponseModel } from "../types";


class FundLogService {
    private dbService;

    constructor() {
        this.dbService = new FundLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default FundLogService;
